<script lang="ts" setup>
defineProps<{
  title?: string
}>()

const slots = useSlots()
const isTitleEndSlotInUse = computed(() => slots?.['title-end']?.({}))
</script>

<template>
  <div class="flex flex-col gap-4">
    <div class="flex items-center justify-between gap-2 empty:hidden">
      <slot name="title">
        <span
          v-if="title"
          class="font-semibold"
        >
          {{ title }}
        </span>
        <span
          v-if="isTitleEndSlotInUse"
          class="ml-auto mr-0"
        >
          <slot name="title-end" />
        </span>
      </slot>
    </div>
    <slot />
  </div>
</template>
